import CreateAxiosInstance from './axiosConfig';
const APIClient = CreateAxiosInstance(import.meta.env.VITE_API_BASE_URL);
const AWSClient = CreateAxiosInstance(null, false);

export async function getSignedURL(fileName, contentType) {
  const encodedName = encodeURIComponent(fileName);
  const encodedType = encodeURIComponent(contentType);
  return await APIClient.get(
    `/aws/get-signed-url?file_name=${encodedName}&content_type=${encodedType}`,
    {
      defaultErrorMessage: 'There was an error uploading your file. Please try again later.',
    }
  );
}

export async function getSignedURLForTemplates(fileName, contentType) {
  const encodedName = encodeURIComponent(fileName);
  const encodedType = encodeURIComponent(contentType);
  return await APIClient.get(
    `/aws/get-signed-url-for-templates?file_name=${encodedName}&content_type=${encodedType}`,
    {
      defaultErrorMessage: 'There was an error uploading your file. Please try again later.',
    }
  );
}

export async function uploadToS3(signedURL, file, contentType) {
  return await AWSClient.put(signedURL, file, {
    headers: {
      'Content-Type': contentType,
    },
    defaultErrorMessage: 'There was an error uploading your file. Please try again later.',
  });
}
